import type { Band } from '../api/types'

export type BandShape = 'circle-check' | 'triangle' | 'diamond' | 'octagon' | 'dashed-circle'

export interface BandMeta {
  code: Band
  label: string
  /** Shape of the icon that accompanies the label, so colour is never the only cue. */
  shape: BandShape
  color: string
  soft: string
  ink: string
  rank: number
}

/** Stable < warning < preventive < critical; "not assessed" is not a severity. */
export const BAND_ORDER: Band[] = ['stable', 'warning', 'preventive', 'critical', 'not_assessed']

const META: Record<Band, BandMeta> = {
  stable: { code: 'stable', label: 'Estable', shape: 'circle-check', color: 'var(--band-stable)', soft: 'var(--band-stable-soft)', ink: 'var(--band-stable-ink)', rank: 0 },
  warning: { code: 'warning', label: 'Advertencia', shape: 'triangle', color: 'var(--band-warning)', soft: 'var(--band-warning-soft)', ink: 'var(--band-warning-ink)', rank: 1 },
  preventive: { code: 'preventive', label: 'Preventivo', shape: 'diamond', color: 'var(--band-preventive)', soft: 'var(--band-preventive-soft)', ink: 'var(--band-preventive-ink)', rank: 2 },
  critical: { code: 'critical', label: 'Crítico', shape: 'octagon', color: 'var(--band-critical)', soft: 'var(--band-critical-soft)', ink: 'var(--band-critical-ink)', rank: 3 },
  not_assessed: { code: 'not_assessed', label: 'Sin evaluar', shape: 'dashed-circle', color: 'var(--band-na)', soft: 'var(--band-na-soft)', ink: 'var(--band-na-ink)', rank: -1 },
}

export function bandMeta(code: string | null | undefined): BandMeta {
  return META[(code ?? '') as Band] ?? META.not_assessed
}

export function isCriticalBand(code: string | null | undefined): boolean {
  return code === 'critical'
}

export function worstBand(codes: (string | null | undefined)[]): Band {
  let worst: BandMeta = META.not_assessed
  for (const code of codes) {
    const meta = bandMeta(code)
    if (meta.rank > worst.rank) worst = meta
  }
  return worst.code
}

/** One decimal, half up; a missing score is a dash, never 0. */
export function formatScore(total: string | number | null | undefined): string {
  if (total === null || total === undefined || total === '') return '—'
  const value = typeof total === 'number' ? total : Number(String(total).replace(',', '.'))
  if (!Number.isFinite(value)) return '—'
  return (Math.round((value + Number.EPSILON) * 10) / 10).toFixed(1)
}
